import PageHeader from '@app/components/Layout/PageHeader';
import {
    SCHOOL_PROPERTY_GROUP,
    SCHOOL_SETTING_FOODKID_GROUP,
    SETTING_GLOBAL_GROUP,
    TabSchoolPropertyList,
} from '@app/constants/schoolSetting.const';

import './custom.scss';

import { useSchoolSettings } from './hooks/useSchoolSettings';
import TabHeader from './components/TabHeader';
import TabPanel from './components/TabPanel';
import PropertyGroup from './components/PropertyGroup';
import ServiceTable from './components/ServiceTable';
import SettingItem from './components/SettingItem';
import { MergedProperty } from './types';

const SettingSchoolRefact = () => {
    const {
        mergedSettings,
        kidGroupList,
        proPackagingCache,
        invoiceForm,
        schoolPropertyList,
        onSave,
        onChangeData,
    } = useSchoolSettings();

    /**
     * Render nội dung từng tab theo group
     */
    const renderTabContent = (items: MergedProperty[], groupId: number) => {
        if (items.length === 0) return null;

        // FOODKID: có subgroup
        if (groupId === SCHOOL_PROPERTY_GROUP.FOODKID) {
            return (
                <PropertyGroup
                    items={items}
                    groupConfigs={SCHOOL_SETTING_FOODKID_GROUP}
                    groupId={groupId}
                    kidGroupList={kidGroupList}
                    proPackagingCache={proPackagingCache}
                    invoiceForm={invoiceForm}
                    onChange={onChangeData}
                />
            );
        }

        // SERVICE: table riêng
        if (groupId === SCHOOL_PROPERTY_GROUP.SERVICE) {
            return <ServiceTable items={items} onChange={onChangeData} />;
        }

        // GLOBAL: có subgroup
        if (groupId === SCHOOL_PROPERTY_GROUP.GLOBAL) {
            return (
                <PropertyGroup
                    items={items}
                    groupConfigs={SETTING_GLOBAL_GROUP}
                    groupId={groupId}
                    kidGroupList={kidGroupList}
                    proPackagingCache={proPackagingCache}
                    invoiceForm={invoiceForm}
                    onChange={onChangeData}
                />
            );
        }

        // Default: render từng item
        return items.map((item) => (
            <SettingItem
                key={item.ps_id}
                item={item}
                kidGroupList={kidGroupList}
                proPackagingCache={proPackagingCache}
                invoiceForm={invoiceForm}
                onChange={onChangeData}
            />
        ));
    };

    return (
        <>
            <PageHeader pageTitle="Thông tin trường học" />
            <div className="content">
                <div className="row">
                    <div className="tabbable tab-content-bordered school-setting">
                        <ul className="nav nav-tabs nav-tabs-highlight nav-justified">
                            <TabHeader tabs={TabSchoolPropertyList} />
                        </ul>

                        {schoolPropertyList.length > 0 && (
                            <div className="tab-content">
                                {TabSchoolPropertyList.map((tab) => {
                                    const list = mergedSettings.filter(
                                        (item) => item.p_group === tab.id,
                                    );
                                    return (
                                        <TabPanel
                                            key={tab.id}
                                            tabId={tab.id}
                                            isActive={tab.id === 1}
                                            onSave={onSave}
                                        >
                                            {renderTabContent(list, tab.id)}
                                        </TabPanel>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default SettingSchoolRefact;
